import { toQuery, type HttpClient } from '../client';

/** 期初建账导入行：materialId 与 materialCode 至少提供一个（后端可按编码回查主数据）。 */
export interface OpeningImportItem {
  /** 雪花 ID 必须用字符串传输，转 Number 会丢精度。 */
  materialId?: string;
  materialCode?: string;
  materialName?: string;
  spec?: string;
  unitName?: string;
  batchNo?: string;
  /** yyyy-MM-dd */
  expiryDate?: string;
  qty: number;
  price: number;
}

export interface OpeningImportRequest {
  /** 雪花 ID 必须用字符串传输，转 Number 会丢精度。 */
  warehouseId: string;
  ownerType?: string;
  importBatchNo?: string;
  remark?: string;
  items: OpeningImportItem[];
}

/** 期初明细行（wl_opening）。 */
export interface OpeningRow {
  id: string;
  orgId: string;
  warehouseId: string;
  materialId: string;
  materialCode: string | null;
  materialName: string | null;
  spec: string | null;
  unitName: string | null;
  batchNo: string | null;
  expiryDate: string | null;
  qty: number;
  price: number;
  amount: number;
  ownerType: string | null;
  /** DRAFT / POSTED */
  status: string;
  importBatchNo: string | null;
  bizDate: string;
}

export interface OpeningQuery {
  importBatchNo?: string;
  status?: string;
  warehouseId?: string;
  size?: number;
}

const BASE = '/wl/opening';

/** 期初建账：导入（DRAFT）→ 过账 → 回滚。 */
export function createOpeningApi(http: HttpClient) {
  return {
    list(query: OpeningQuery = {}): Promise<OpeningRow[]> {
      return http.request<OpeningRow[]>({ path: BASE, query: toQuery(query) });
    },
    import(request: OpeningImportRequest): Promise<{ importBatchNo: string; itemCount: number; totalAmount: number; status: string }> {
      return http.request<{ importBatchNo: string; itemCount: number; totalAmount: number; status: string }>({
        method: 'POST', path: `${BASE}/import`, body: request
      });
    },
    post(batchNo: string): Promise<{ importBatchNo: string; posted: number }> {
      return http.request<{ importBatchNo: string; posted: number }>({
        method: 'POST', path: `${BASE}/${encodeURIComponent(batchNo)}/post`
      });
    },
    rollback(batchNo: string): Promise<{ importBatchNo: string; deletedDrafts: number; reversedPosted: number }> {
      return http.request<{ importBatchNo: string; deletedDrafts: number; reversedPosted: number }>({
        method: 'POST', path: `${BASE}/${encodeURIComponent(batchNo)}/rollback`
      });
    }
  };
}

export type OpeningApi = ReturnType<typeof createOpeningApi>;
